const replaceComma = (value: string) => {
  return value?.toString().replace(/\./g, "");
};
export default replaceComma;
